module.exports = __webpack_public_path__ + "img/support4.adc4b42a.jpg";